import React from "react";
import { connect } from "react-redux";
import { get as _get } from "lodash";
import { updateLegacySessionKey } from "../../store/actions";
import {
  matchSiteCanvassToCampaign,
  pullCampaignScripts,
  pullSiteRoutes,
} from "../../store/api/calls";

import { Link } from "react-router-dom";
import { siteCanvassEditCreateForm } from "../../utils/forms/formFields";

import NavBaseTemplate from "../templates/NavBaseTemplate";
import DataTable from "../theme/tables/DataTable";
import FeedbackTile from "../theme/modals/FeedbackTile";
import Moment from "moment";
import "../../styles/alerts.scss";
import Tabs from "../theme/menus/Tabs";
import AlertConfigEditor from "../subscreens/AlertConfigs";
import {withRouter} from "../../utils/withRouter";

class SiteRoutesScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      editModalOpen: false,
      deleteModalOpen: false,
      editingInstance: {},
      feedbackTileVisibile: true,
      selectedSiteCanvass: {},
      script: {},
      paramCanvass: 0,
      section: "siteroutes",
      // feedbackTileColor: ,
      loadSubmodules: false,
    };

    this.formInputs = siteCanvassEditCreateForm;
  }

  componentDidMount() {
    const { params } = this.props;


    this.setState({ paramCanvass: +params.sitecanvass_id, loading: true });

    matchSiteCanvassToCampaign(params.sitecanvass_id)
      .then((sitecanvass_data) =>
        this.setState({
          selectedSiteCanvass: sitecanvass_data,
          loadSubmodules: true,
        })
      )
      .then(() => pullSiteRoutes(params.sitecanvass_id))
      .then(() => this.handleScripts());
  }

  handleScripts() {
    // this.state.selectedSiteCanvass.script
    if (!this.props.scripts) {
      pullCampaignScripts().then((res) => {
        let script = this.props.scripts.find(
          (item) => item.id === this.state.selectedSiteCanvass.script
        );
        this.setState({ script, loading: false });
      });
    } else {
      let script = this.props.scripts.find(
        (item) => item.id === this.state.selectedSiteCanvass.script
      );
      this.setState({ script, loading: false });
    }
  }

  _filterKeysForDataTable() {
    let script = _get(this, "state.script.name", "");
    return this.props.siteRoutes.map((d, i) => {
      return {
        color: (
          <div
            key={i}
            style={{
              height: "12px",
              width: "12px",
              borderRadius: "2px",
              backgroundColor: d.hex_color,
            }}
          />
        ),
        _color: d.hex_color,
        name: d.siteroute_name,
        script,
        seats: d.routeseats.length,
        created_on: new Moment(d.created_at).format("MM/DD/YY"),
        _created_on: new Moment(d.created_at),
        _data: d,
      };
    });
  }

  render() {
    return (
      <NavBaseTemplate disabled={true} >
        <Tabs
          tabs={[
            {
              display: "Site Routes",
              onClick: () => this.setState({ section: "siteroutes" }),
              active: this.state.section === "siteroutes",
            },
            // {
            //     display: 'Alerts',
            //     onClick: () => this.setState({section: 'alerts'}),
            //     active: this.state.section === 'alerts'
            // },
          ]}
        />

        {this.state.section === "siteroutes" && (
          <>
            <div className="button-table-top-wrapper">
              <Link to={`/sitecanvass/${this.state.paramCanvass}/schedule`}>
                <button className="button primary-milligram">
                  <i className="fas fa-clock" style={{ marginRight: "1em" }} />
                  Schedule
                </button>
              </Link>
              <Link to={`/sitecanvass/${this.state.paramCanvass}/edit`}>
                <button className="button primary">
                  <i className="fas fa-edit" style={{ marginRight: "1em" }} />
                  Edit Routes
                </button>
              </Link>
              <Link to={`/sitecanvass/${this.state.paramCanvass}/quickedit`}>
                <button className="button primary">
                  <i
                    className="fas fa-fighter-jet"
                    style={{ marginRight: "1em" }}
                  />
                  Quick Edit
                </button>
              </Link>
            </div>
            <DataTable
              data={this._filterKeysForDataTable() || []}
              title={`Site Routes: ${
                Object.keys(this.state.selectedSiteCanvass).length
                  ? this.state.selectedSiteCanvass.name
                  : ""
              }`}
            />
          </>
        )}

        {this.state.section === "alerts" && !!this.state.loadSubmodules && (
          <>
            <AlertConfigEditor
              siteCanvass={this.state.selectedSiteCanvass}
              doorCanvass={{}}
            />
          </>
        )}

        <FeedbackTile
          text={
            <div>
              <i
                className=" fas fa-asterisk fa-spin"
                style={{ marginRight: "15px" }}
              />
              Loading...
            </div>
          }
          visible={this.props.loading || this.state.loading}
        />

        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk" style={{ marginRight: "15px" }} />
            </div>
          }
          visible={this.state.showSuccess}
        />

        <FeedbackTile
          text={
            <div>
              <i
                className="fas fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              {typeof this.props.error === "string"
                ? this.props.error
                : "Server Error"}
            </div>
          }
          visible={this.props.error}
          classNames="danger"
        />
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.campaigns?.data,
  focusedCampaign: state.session.focusedCampaign,
  siteRoutes: state.siteRoutes.data,
  loading: state.siteRoutes.loading || state.alertConfigs.loading,
  error: state.siteRoutes.error || state.alertConfigs.error,
  is_admin: state.permissions.is_admin,
  scripts: state.scripts.data,
});

//tHIS NEEDS tO MOVE tO tHE tEMPLAtE SCREEN!
const mapDispatchToProps = (dispatch) => ({
  updateLegacySessionKey: (key) => dispatch(updateLegacySessionKey(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SiteRoutesScreen));
